import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const SumRedWorkReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default SumRedWorkReport
